import { AddressErrors, IAddress } from 'models/Address';
import { get, post } from 'utils/network';
import { ApiRoute } from '../../utils/config';
import { Address } from '../../models/address.types';

export const createAddress = async (address: IAddress) => {
  const payload = { shipping_address: address };

  return post<IAddress | AddressErrors>(ApiRoute.CREATE_ADDRESS, payload);
};

// Gets all addresses. Returns undefined if AddressError.
export const getAddresses = async (): Promise<IAddress[] | undefined> => {
  const response = await get<IAddress[] | AddressErrors>(ApiRoute.GET_ADDRESSES);
  const addresses = response.parsedBody;

  // if addresses is not an array, return undefined for error state
  if (!Array.isArray(addresses)) {
    return undefined;
  }
  return addresses;
};

export const createBillingAddress = async (address: Address) => {
  const payload = {
    billing_address: {
      address: address.address1,
      address2: address.address2,
      city: address.city,
      state: address.state,
      zip: address.zip,
    },
  };

  return post(`${ApiRoute.USERS}/${address.userId}/billing_address`, payload);
};
